<template>
      <header class="header">
        <div class="widthesp" style="height: 64px; display: flex !important;
  align-items: center; justify-content: space-between;">
          <v-app-bar-nav-icon
            @click="drawer = !drawer"
            class="showScreen"
            style="color: white !important"
          ></v-app-bar-nav-icon>
          <div>
            <a href="https://www.odontoprev.com.br">
              <div class="odp-CustomSVGIcon" style="color: white">
                <svg
                  viewBox="0 0 192 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="margin-top: 7px !important"
                >
                  <path
                    d="M15.3001 28.4436C5.35075 28.4436 -0.52365 4.06141 7.69766 4.06141C10.6253 4.06141 10.8824 7.93931 15.3144 7.93931C19.5988 7.93931 20.0748 4.06141 22.9311 4.06141C31.0572 4.06141 25.1114 28.4483 15.3144 28.4483L15.3001 28.4436ZM22.9025 0.250214C20.0463 0.250214 18.3944 1.89379 17.2852 2.98475C16.295 3.93755 16.057 4.12811 15.3001 4.12811C14.5432 4.12811 14.2528 3.93279 13.3293 3.01333C12.3105 1.97955 10.592 0.250214 7.69766 0.250214C6.41601 0.240232 5.15573 0.578899 4.05147 1.23003C2.94722 1.88116 2.04048 2.82029 1.42814 3.94708C0.476045 5.60495 0 7.75828 0 10.2832C0 14.5946 1.42814 19.8112 3.73696 23.9368C6.74556 29.3106 10.8538 32.25 15.3001 32.25C24.5925 32.25 30.5336 19.1919 30.5336 10.1974C30.5336 7.68205 30.0575 5.5716 29.1054 3.92802C28.5024 2.80937 27.6064 1.87607 26.5137 1.22816C25.421 0.580263 24.1726 0.242199 22.9025 0.250214Z"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M47.9847 12.6081C50.4934 12.6081 52.112 14.3279 52.112 16.9862C52.112 19.6446 50.5125 21.412 48.0418 21.412C45.5711 21.412 43.943 19.635 43.943 16.9862C43.943 14.3375 45.5283 12.6081 47.9847 12.6081ZM48.0418 9.62109C43.4908 9.62109 40.5488 12.5128 40.5488 16.9862C40.5488 21.4596 43.4908 24.3704 48.0418 24.3704C52.5928 24.3704 55.4776 21.4739 55.4776 16.9862C55.4776 12.4986 52.5595 9.62109 48.0418 9.62109Z"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M68.4466 16.9579C68.4466 19.7544 67.1232 21.3599 64.8144 21.3599C62.5056 21.3599 60.9346 19.6544 60.9346 17.0104C60.9346 14.3663 62.4389 12.6656 64.743 12.6656C67.047 12.6656 68.4276 14.2282 68.4276 16.9532L68.4466 16.9579ZM72.5216 21.2408C71.9265 20.8358 71.7123 20.2356 71.7123 18.9636V5.03842C71.7123 4.77182 71.6065 4.51614 71.4181 4.32763C71.2297 4.13912 70.9742 4.03321 70.7078 4.03321H69.432C69.2999 4.03258 69.169 4.05815 69.0469 4.10845C68.9247 4.15874 68.8138 4.23276 68.7204 4.32623C68.627 4.41969 68.553 4.53076 68.5027 4.653C68.4525 4.77524 68.4269 4.90624 68.4276 5.03842V11.4317C67.9012 10.8402 67.2516 10.3714 66.5244 10.0586C65.7973 9.74584 65.0104 9.59657 64.2193 9.62139C60.1682 9.62139 57.5547 12.5465 57.5547 17.0675C57.5547 21.3551 60.2967 24.3707 64.2193 24.3707C66.3139 24.3707 68.0039 23.4799 68.8941 21.9173C69.1416 23.3846 70.0937 24.2993 71.479 24.3707H71.5409C72.026 24.392 72.4999 24.2208 72.8596 23.8943C73.0161 23.7331 73.1389 23.5421 73.2207 23.3327C73.3024 23.1232 73.3415 22.8995 73.3356 22.6747C73.3181 22.4264 73.2494 22.1843 73.1339 21.9638C73.0184 21.7432 72.8585 21.549 72.6644 21.3932L72.5216 21.2408Z"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M147.613 17.0246C147.613 19.6639 146.108 21.3694 143.804 21.3694C141.5 21.3694 140.12 19.8068 140.12 17.0818C140.12 14.3568 141.443 12.6846 143.752 12.6846C146.061 12.6846 147.632 14.3902 147.632 17.0294L147.613 17.0246ZM144.328 9.66903C142.233 9.66903 140.543 10.5599 139.653 12.1225C139.406 10.6552 138.454 9.74049 137.068 9.66903C136.818 9.65065 136.566 9.6834 136.329 9.7653C136.092 9.84719 135.874 9.97652 135.688 10.1454C135.53 10.3062 135.407 10.4971 135.325 10.7067C135.244 10.9162 135.205 11.1401 135.212 11.365C135.229 11.6107 135.296 11.8502 135.409 12.069C135.522 12.2877 135.678 12.481 135.869 12.637L136.007 12.7799C136.607 13.1896 136.816 13.7851 136.816 15.0619V29.0013C136.817 29.2675 136.923 29.5225 137.112 29.7107C137.3 29.899 137.554 30.0053 137.82 30.0065H139.096C139.363 30.0065 139.618 29.9006 139.806 29.7121C139.995 29.5236 140.101 29.2679 140.101 29.0013V22.6033C140.626 23.1959 141.276 23.6653 142.003 23.9782C142.73 24.2911 143.518 24.4397 144.309 24.4136C148.36 24.4136 150.974 21.4933 150.974 16.9675C150.974 12.6799 148.232 9.66427 144.309 9.66427"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M82.3562 21.412C79.9046 21.412 78.2622 19.635 78.2622 16.9862C78.2622 14.3375 79.8475 12.6081 82.3039 12.6081C84.7603 12.6081 86.4264 14.3279 86.4264 16.9862C86.4264 19.6446 84.8269 21.412 82.3562 21.412ZM82.3562 9.62109C77.8052 9.62109 74.8633 12.5128 74.8633 16.9862C74.8633 21.4596 77.8052 24.3704 82.3562 24.3704C86.9072 24.3704 89.7968 21.4739 89.7968 16.9862C89.7968 12.4986 86.8501 9.62109 82.3562 9.62109Z"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M100.089 9.62171C98.2647 9.61828 96.5119 10.3336 95.2099 11.6131V10.1458C95.2099 10.0068 95.1547 9.87348 95.0565 9.7752C94.9583 9.67692 94.8251 9.62171 94.6863 9.62171H92.9963C92.8574 9.62171 92.7242 9.67692 92.626 9.7752C92.5278 9.87348 92.4727 10.0068 92.4727 10.1458V23.8613C92.4727 23.9965 92.5263 24.1262 92.6218 24.2218C92.7174 24.3174 92.8469 24.3711 92.982 24.3711H95.2528C95.3194 24.3717 95.3856 24.3591 95.4473 24.334C95.5091 24.3089 95.5653 24.2718 95.6127 24.2248C95.66 24.1779 95.6976 24.122 95.7233 24.0604C95.7489 23.9988 95.7621 23.9328 95.7621 23.8661L95.7859 16.8201C95.8145 14.3047 97.314 12.6087 99.5277 12.6087C101.589 12.6087 102.636 13.9903 102.636 16.7105V23.8565C102.636 23.9917 102.69 24.1214 102.785 24.217C102.881 24.3126 103.011 24.3663 103.146 24.3663H105.416C105.551 24.3663 105.681 24.3126 105.777 24.217C105.872 24.1214 105.926 23.9917 105.926 23.8565V16.4485C105.926 11.9751 103.912 9.60742 100.104 9.60742"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M116.632 20.8122C116.35 20.8194 116.074 20.8946 115.827 21.0314C115.533 21.1903 115.208 21.283 114.875 21.3029C114.658 21.3119 114.44 21.2768 114.237 21.1999C114.033 21.1229 113.847 21.0057 113.69 20.8551C113.527 20.7001 113.398 20.5138 113.31 20.3075C113.222 20.1011 113.176 19.879 113.176 19.6546V12.5371H116.632C116.792 12.5371 116.946 12.4734 117.059 12.3599C117.173 12.2465 117.236 12.0926 117.236 11.9321V10.2123C117.237 10.1325 117.222 10.0533 117.192 9.97932C117.161 9.90536 117.117 9.8381 117.061 9.78141C117.005 9.72472 116.938 9.67973 116.864 9.64903C116.79 9.61833 116.711 9.60252 116.632 9.60252H113.133V6.81082C113.133 6.65794 113.072 6.51132 112.964 6.40321C112.856 6.29511 112.709 6.23438 112.557 6.23438H110.443C110.29 6.23437 110.144 6.29511 110.036 6.40321C109.928 6.51132 109.867 6.65794 109.867 6.81082V9.60252H108.039C107.877 9.60378 107.722 9.66908 107.608 9.7842C107.494 9.89931 107.43 10.0549 107.43 10.2171V11.9274C107.431 12.0887 107.496 12.2431 107.61 12.3572C107.724 12.4713 107.878 12.5359 108.039 12.5371H109.867V18.7303C109.867 21.3124 110.653 24.39 114.399 24.39C115.746 24.39 116.779 24.0374 117.379 23.3991C117.664 23.0481 117.818 22.6081 117.812 22.1557C117.826 21.988 117.806 21.8193 117.753 21.6597C117.7 21.5 117.615 21.3527 117.504 21.2264C117.393 21.1002 117.258 20.9976 117.106 20.9248C116.955 20.852 116.79 20.8104 116.622 20.8027"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M130.436 16.9862C130.436 19.6731 128.837 21.412 126.366 21.412C123.895 21.412 122.267 19.635 122.267 16.9862C122.267 14.3375 123.857 12.6081 126.314 12.6081C128.77 12.6081 130.436 14.3279 130.436 16.9862ZM126.366 9.62109C121.815 9.62109 118.873 12.5128 118.873 16.9862C118.873 21.4596 121.815 24.3704 126.366 24.3704C130.917 24.3704 133.802 21.4739 133.802 16.9862C133.802 12.4986 130.884 9.62109 126.366 9.62109Z"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M160.49 9.64939C159.66 9.71197 158.855 9.95812 158.132 10.3701C157.41 10.782 156.787 11.3494 156.31 12.0314V10.283C156.31 10.199 156.293 10.1158 156.261 10.0383C156.229 9.96081 156.181 9.89053 156.121 9.83157C156.062 9.7726 155.991 9.72613 155.913 9.69486C155.835 9.66358 155.751 9.64812 155.667 9.64939H154.192C154.024 9.65063 153.864 9.71779 153.745 9.83635C153.627 9.9549 153.56 10.1153 153.559 10.283V23.7937C153.56 23.9538 153.624 24.1069 153.737 24.2201C153.85 24.3333 154.003 24.3975 154.163 24.3987H156.243C156.403 24.3987 156.556 24.3356 156.669 24.2232C156.783 24.1108 156.847 23.9581 156.848 23.7985L156.872 16.2428C156.872 13.8941 158.686 12.765 160.48 12.6936C160.685 12.7066 160.89 12.6762 161.082 12.6045C161.274 12.5328 161.448 12.4214 161.594 12.2775C161.74 12.1336 161.854 11.9605 161.929 11.7695C162.004 11.5785 162.037 11.3739 162.027 11.1691C162.037 10.9647 162.003 10.7606 161.928 10.5702C161.853 10.3798 161.739 10.2073 161.593 10.0639C161.447 9.92055 161.272 9.80955 161.081 9.73813C160.889 9.66672 160.684 9.63648 160.48 9.64939"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M172.766 15.4244C172.766 15.5053 172.766 15.6864 172.766 15.8198H166.054C166.061 15.3702 166.158 14.9266 166.338 14.5147C166.518 14.1029 166.779 13.731 167.104 13.4206C167.429 13.1103 167.812 12.8678 168.232 12.7072C168.652 12.5466 169.099 12.471 169.548 12.485C171.562 12.485 172.766 13.5855 172.766 15.4339V15.4244ZM169.601 9.65992C165.53 9.65992 162.684 12.666 162.684 16.9679C162.684 21.6271 165.607 24.4093 170.505 24.4093C172.021 24.3432 173.507 23.9704 174.875 23.3135C175.015 23.2498 175.125 23.1346 175.183 22.9919C175.241 22.8491 175.241 22.6897 175.185 22.5465L174.623 20.9982C174.595 20.9207 174.551 20.8497 174.494 20.7897C174.437 20.7297 174.369 20.6819 174.293 20.6493C174.217 20.6167 174.136 20.6 174.053 20.6002C173.971 20.6004 173.889 20.6175 173.814 20.6505C172.767 21.13 171.632 21.3894 170.481 21.4127C167.277 21.4127 166.102 19.6786 166.054 18.1494H174.261C175.556 18.1494 176.108 17.5396 176.108 16.1056C176.108 12.1229 173.614 9.65039 169.601 9.65039"
                    fill="currentColor"
                    class="primary"
                  ></path>
                  <path
                    d="M191.895 9.9267C191.837 9.84181 191.76 9.77225 191.669 9.72409C191.579 9.67593 191.478 9.65063 191.376 9.65039H189.357C189.231 9.65066 189.109 9.68902 189.005 9.76045C188.901 9.83187 188.822 9.93301 188.777 10.0506L184.863 20.2598C184.839 20.3292 184.793 20.3891 184.732 20.4309C184.671 20.4728 184.599 20.4946 184.525 20.4933C184.452 20.4953 184.379 20.4738 184.318 20.4318C184.258 20.3899 184.212 20.3296 184.187 20.2598L180.265 10.0696C180.22 9.95206 180.14 9.85093 180.036 9.7795C179.933 9.70808 179.81 9.66971 179.684 9.66945H177.68C177.578 9.67005 177.478 9.69554 177.389 9.74371C177.299 9.79187 177.223 9.86123 177.166 9.94576C177.107 10.0286 177.071 10.1251 177.06 10.2259C177.049 10.3268 177.064 10.4288 177.104 10.5222L181.507 21.589C182.207 23.4946 182.821 24.4188 184.445 24.4188H184.664C186.044 24.4188 186.758 23.7042 187.601 21.4794L191.957 10.5222C191.994 10.4284 192.008 10.3268 191.997 10.2263C191.986 10.1258 191.951 10.0295 191.895 9.94576"
                    fill="currentColor"
                    class="primary"
                  ></path>
                </svg>
              </div>
            </a>

            <span class="bi-versao"> {{ versaoF }} {{ versaoB }} </span>
          </div>

         <!-- <div class="hideScreen">
            <a
              href="https://www.odontoprev.com.br/imprensa"
              class="v-btn v-btn--router v-btn--text theme--dark v-size--default"
            >
              <span class="btnheader">Imprensa</span
              >
            </a>
          </div>-->
          <!-- <div class="hideScreen">
            <a
              href="https://www.instagram.com/odontoprevoficial/"
              target="_blank"
              class="v-btn v-btn--icon v-btn--round theme--dark v-size--small"
            >
              <span class="v-btn__content">
                <span
                  aria-hidden="true"
                  class="v-icon notranslate theme--dark"
                  style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    aria-hidden="true"
                    class="v-icon__svg"
                    style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                  >
                    <path
                      d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"
                    ></path>
                  </svg>
                </span>
                
              </span>
            </a>
            <a
              href="https://www.facebook.com/OdontoprevOficial"
              target="_blank"
              class="v-btn v-btn--icon v-btn--round theme--dark v-size--small"
            >
              <span class="v-btn__content">
                <span
                  aria-hidden="true"
                  class="v-icon notranslate theme--dark"
                  style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    aria-hidden="true"
                    class="v-icon__svg"
                    style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                  >
                    <path
                      d="M12 2.04C6.5 2.04 2 6.53 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.85C10.44 7.34 11.93 5.96 14.22 5.96C15.31 5.96 16.45 6.15 16.45 6.15V8.62H15.19C13.95 8.62 13.56 9.39 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96A10 10 0 0 0 22 12.06C22 6.53 17.5 2.04 12 2.04Z"
                    ></path>
                  </svg>
                </span>
                <
              </span>
            </a>
            <a
              href="https://www.linkedin.com/company/odontoprev/mycompany/"
              target="_blank"
              class="v-btn v-btn--icon v-btn--round theme--dark v-size--small"
            >
              <span class="v-btn__content">
                <span
                  aria-hidden="true"
                  class="v-icon notranslate theme--dark"
                  style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    aria-hidden="true"
                    class="v-icon__svg"
                    style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                  >
                    <path
                      d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M18.5 18.5V13.2A3.26 3.26 0 0 0 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17A1.4 1.4 0 0 1 15.71 13.57V18.5H18.5M6.88 8.56A1.68 1.68 0 0 0 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19A1.69 1.69 0 0 0 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56M8.27 18.5V10.13H5.5V18.5H8.27Z"
                    ></path>
                  </svg>
                </span>
                
              </span>
            </a>
            <a
              href="https://open.spotify.com/show/4i4UxAx8l9kf38DYhoCwMW"
              target="_blank"
              class="v-btn v-btn--icon v-btn--round theme--dark v-size--small"
            >
              <span class="v-btn__content">
                <span
                  aria-hidden="true"
                  class="v-icon notranslate theme--dark"
                  style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    aria-hidden="true"
                    class="v-icon__svg"
                    style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                  >
                    <path
                      d="M17.9,10.9C14.7,9 9.35,8.8 6.3,9.75C5.8,9.9 5.3,9.6 5.15,9.15C5,8.65 5.3,8.15 5.75,8C9.3,6.95 15.15,7.15 18.85,9.35C19.3,9.6 19.45,10.2 19.2,10.65C18.95,11 18.35,11.15 17.9,10.9M17.8,13.7C17.55,14.05 17.1,14.2 16.75,13.95C14.05,12.3 9.95,11.8 6.8,12.8C6.4,12.9 5.95,12.7 5.85,12.3C5.75,11.9 5.95,11.45 6.35,11.35C10,10.25 14.5,10.8 17.6,12.7C17.9,12.85 18.05,13.35 17.8,13.7M16.6,16.45C16.4,16.75 16.05,16.85 15.75,16.65C13.4,15.2 10.45,14.9 6.95,15.7C6.6,15.8 6.3,15.55 6.2,15.25C6.1,14.9 6.35,14.6 6.65,14.5C10.45,13.65 13.75,14 16.35,15.6C16.7,15.75 16.75,16.15 16.6,16.45M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                    ></path>
                  </svg>
                </span>
                
              </span>
            </a>
            <a
              href="https://www.youtube.com/user/OdontoPrevOficial"
              target="_blank"
              class="v-btn v-btn--icon v-btn--round theme--dark v-size--small"
            >
              <span class="v-btn__content">
                <span
                  aria-hidden="true"
                  class="v-icon notranslate theme--dark"
                  style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    aria-hidden="true"
                    class="v-icon__svg"
                    style="font-size: 1.25rem; height: 1.25rem; width: 1.25rem"
                  >
                    <path
                      d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z"
                    ></path>
                  </svg>
                </span>
              </span>
            </a>
            <a
              href="https://www.tiktok.com/@odontoprevoficial?lang=pt-BR"
              target="_blank"
              class="v-btn v-btn--icon v-btn--round theme--dark v-size--small"
            >
              <span class="v-btn__content">
                
                <div
                  class="odp-CustomSVGIcon"
                  style="
                    --color: white;
                    --secondary-color: white;
                    --size: 1.25rem;
                  "
                >
                  <svg
                    style="width: 20px; height: 20px"
                    viewBox="0 0 512 512"
                    id="icons"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
                      fill="currentColor"
                      class="primary"
                    ></path>
                  </svg>
                </div>
              </span>
            </a>
          </div> -->

          <div class="d-flex">
            <div v-show="isLogged" style="display: flex; color: white">
              <span
                class="pa-4"
                style="
                  padding-left: 34px !important;
                  padding-right: 0 !important;
                "
              >
                <i class="fas fa-user"></i>
                &nbsp;{{ userNameLogged }}
              </span>
            </div>

            <div class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-on:click="toggleDarkMode"
                    v-bind="attrs"
                    v-on="on"
                    style="color: white"
                  >
                    <i class="fas fa-adjust"></i>
                  </v-btn>
                </template>
                <span>Acessibilidade - Fundo Escuro</span>
              </v-tooltip>

              <div v-if="isLogged">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-on:click="signout"
                      v-bind="attrs"
                      v-on="on"
                      style="color: white"
                    >
                      <i class="fas fa-sign-out-alt"></i>
                    </v-btn>
                  </template>
                  <span>Sair</span>
                </v-tooltip>
              </div>
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-on:click="login"
                      v-bind="attrs"
                      v-on="on"
                      style="color: white"
                    >
                      <i class="fas fa-sign-in-alt"></i>
                    </v-btn>
                  </template>
                  <span>Login</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </div>

    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list-item style="margin: 8px auto 0 auto">
        <v-list-item-title>
          <div
            class="odp-CustomSVGIcon"
            style="--color: #011a2e; width: 80%; --height: 3rem; --size: 50px"
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 192 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.3001 28.4436C5.35075 28.4436 -0.52365 4.06141 7.69766 4.06141C10.6253 4.06141 10.8824 7.93931 15.3144 7.93931C19.5988 7.93931 20.0748 4.06141 22.9311 4.06141C31.0572 4.06141 25.1114 28.4483 15.3144 28.4483L15.3001 28.4436ZM22.9025 0.250214C20.0463 0.250214 18.3944 1.89379 17.2852 2.98475C16.295 3.93755 16.057 4.12811 15.3001 4.12811C14.5432 4.12811 14.2528 3.93279 13.3293 3.01333C12.3105 1.97955 10.592 0.250214 7.69766 0.250214C6.41601 0.240232 5.15573 0.578899 4.05147 1.23003C2.94722 1.88116 2.04048 2.82029 1.42814 3.94708C0.476045 5.60495 0 7.75828 0 10.2832C0 14.5946 1.42814 19.8112 3.73696 23.9368C6.74556 29.3106 10.8538 32.25 15.3001 32.25C24.5925 32.25 30.5336 19.1919 30.5336 10.1974C30.5336 7.68205 30.0575 5.5716 29.1054 3.92802C28.5024 2.80937 27.6064 1.87607 26.5137 1.22816C25.421 0.580263 24.1726 0.242199 22.9025 0.250214Z"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M47.9847 12.6081C50.4934 12.6081 52.112 14.3279 52.112 16.9862C52.112 19.6446 50.5125 21.412 48.0418 21.412C45.5711 21.412 43.943 19.635 43.943 16.9862C43.943 14.3375 45.5283 12.6081 47.9847 12.6081ZM48.0418 9.62109C43.4908 9.62109 40.5488 12.5128 40.5488 16.9862C40.5488 21.4596 43.4908 24.3704 48.0418 24.3704C52.5928 24.3704 55.4776 21.4739 55.4776 16.9862C55.4776 12.4986 52.5595 9.62109 48.0418 9.62109Z"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M68.4466 16.9579C68.4466 19.7544 67.1232 21.3599 64.8144 21.3599C62.5056 21.3599 60.9346 19.6544 60.9346 17.0104C60.9346 14.3663 62.4389 12.6656 64.743 12.6656C67.047 12.6656 68.4276 14.2282 68.4276 16.9532L68.4466 16.9579ZM72.5216 21.2408C71.9265 20.8358 71.7123 20.2356 71.7123 18.9636V5.03842C71.7123 4.77182 71.6065 4.51614 71.4181 4.32763C71.2297 4.13912 70.9742 4.03321 70.7078 4.03321H69.432C69.2999 4.03258 69.169 4.05815 69.0469 4.10845C68.9247 4.15874 68.8138 4.23276 68.7204 4.32623C68.627 4.41969 68.553 4.53076 68.5027 4.653C68.4525 4.77524 68.4269 4.90624 68.4276 5.03842V11.4317C67.9012 10.8402 67.2516 10.3714 66.5244 10.0586C65.7973 9.74584 65.0104 9.59657 64.2193 9.62139C60.1682 9.62139 57.5547 12.5465 57.5547 17.0675C57.5547 21.3551 60.2967 24.3707 64.2193 24.3707C66.3139 24.3707 68.0039 23.4799 68.8941 21.9173C69.1416 23.3846 70.0937 24.2993 71.479 24.3707H71.5409C72.026 24.392 72.4999 24.2208 72.8596 23.8943C73.0161 23.7331 73.1389 23.5421 73.2207 23.3327C73.3024 23.1232 73.3415 22.8995 73.3356 22.6747C73.3181 22.4264 73.2494 22.1843 73.1339 21.9638C73.0184 21.7432 72.8585 21.549 72.6644 21.3932L72.5216 21.2408Z"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M147.613 17.0246C147.613 19.6639 146.108 21.3694 143.804 21.3694C141.5 21.3694 140.12 19.8068 140.12 17.0818C140.12 14.3568 141.443 12.6846 143.752 12.6846C146.061 12.6846 147.632 14.3902 147.632 17.0294L147.613 17.0246ZM144.328 9.66903C142.233 9.66903 140.543 10.5599 139.653 12.1225C139.406 10.6552 138.454 9.74049 137.068 9.66903C136.818 9.65065 136.566 9.6834 136.329 9.7653C136.092 9.84719 135.874 9.97652 135.688 10.1454C135.53 10.3062 135.407 10.4971 135.325 10.7067C135.244 10.9162 135.205 11.1401 135.212 11.365C135.229 11.6107 135.296 11.8502 135.409 12.069C135.522 12.2877 135.678 12.481 135.869 12.637L136.007 12.7799C136.607 13.1896 136.816 13.7851 136.816 15.0619V29.0013C136.817 29.2675 136.923 29.5225 137.112 29.7107C137.3 29.899 137.554 30.0053 137.82 30.0065H139.096C139.363 30.0065 139.618 29.9006 139.806 29.7121C139.995 29.5236 140.101 29.2679 140.101 29.0013V22.6033C140.626 23.1959 141.276 23.6653 142.003 23.9782C142.73 24.2911 143.518 24.4397 144.309 24.4136C148.36 24.4136 150.974 21.4933 150.974 16.9675C150.974 12.6799 148.232 9.66427 144.309 9.66427"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M82.3562 21.412C79.9046 21.412 78.2622 19.635 78.2622 16.9862C78.2622 14.3375 79.8475 12.6081 82.3039 12.6081C84.7603 12.6081 86.4264 14.3279 86.4264 16.9862C86.4264 19.6446 84.8269 21.412 82.3562 21.412ZM82.3562 9.62109C77.8052 9.62109 74.8633 12.5128 74.8633 16.9862C74.8633 21.4596 77.8052 24.3704 82.3562 24.3704C86.9072 24.3704 89.7968 21.4739 89.7968 16.9862C89.7968 12.4986 86.8501 9.62109 82.3562 9.62109Z"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M100.089 9.62171C98.2647 9.61828 96.5119 10.3336 95.2099 11.6131V10.1458C95.2099 10.0068 95.1547 9.87348 95.0565 9.7752C94.9583 9.67692 94.8251 9.62171 94.6863 9.62171H92.9963C92.8574 9.62171 92.7242 9.67692 92.626 9.7752C92.5278 9.87348 92.4727 10.0068 92.4727 10.1458V23.8613C92.4727 23.9965 92.5263 24.1262 92.6218 24.2218C92.7174 24.3174 92.8469 24.3711 92.982 24.3711H95.2528C95.3194 24.3717 95.3856 24.3591 95.4473 24.334C95.5091 24.3089 95.5653 24.2718 95.6127 24.2248C95.66 24.1779 95.6976 24.122 95.7233 24.0604C95.7489 23.9988 95.7621 23.9328 95.7621 23.8661L95.7859 16.8201C95.8145 14.3047 97.314 12.6087 99.5277 12.6087C101.589 12.6087 102.636 13.9903 102.636 16.7105V23.8565C102.636 23.9917 102.69 24.1214 102.785 24.217C102.881 24.3126 103.011 24.3663 103.146 24.3663H105.416C105.551 24.3663 105.681 24.3126 105.777 24.217C105.872 24.1214 105.926 23.9917 105.926 23.8565V16.4485C105.926 11.9751 103.912 9.60742 100.104 9.60742"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M116.632 20.8122C116.35 20.8194 116.074 20.8946 115.827 21.0314C115.533 21.1903 115.208 21.283 114.875 21.3029C114.658 21.3119 114.44 21.2768 114.237 21.1999C114.033 21.1229 113.847 21.0057 113.69 20.8551C113.527 20.7001 113.398 20.5138 113.31 20.3075C113.222 20.1011 113.176 19.879 113.176 19.6546V12.5371H116.632C116.792 12.5371 116.946 12.4734 117.059 12.3599C117.173 12.2465 117.236 12.0926 117.236 11.9321V10.2123C117.237 10.1325 117.222 10.0533 117.192 9.97932C117.161 9.90536 117.117 9.8381 117.061 9.78141C117.005 9.72472 116.938 9.67973 116.864 9.64903C116.79 9.61833 116.711 9.60252 116.632 9.60252H113.133V6.81082C113.133 6.65794 113.072 6.51132 112.964 6.40321C112.856 6.29511 112.709 6.23438 112.557 6.23438H110.443C110.29 6.23437 110.144 6.29511 110.036 6.40321C109.928 6.51132 109.867 6.65794 109.867 6.81082V9.60252H108.039C107.877 9.60378 107.722 9.66908 107.608 9.7842C107.494 9.89931 107.43 10.0549 107.43 10.2171V11.9274C107.431 12.0887 107.496 12.2431 107.61 12.3572C107.724 12.4713 107.878 12.5359 108.039 12.5371H109.867V18.7303C109.867 21.3124 110.653 24.39 114.399 24.39C115.746 24.39 116.779 24.0374 117.379 23.3991C117.664 23.0481 117.818 22.6081 117.812 22.1557C117.826 21.988 117.806 21.8193 117.753 21.6597C117.7 21.5 117.615 21.3527 117.504 21.2264C117.393 21.1002 117.258 20.9976 117.106 20.9248C116.955 20.852 116.79 20.8104 116.622 20.8027"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M130.436 16.9862C130.436 19.6731 128.837 21.412 126.366 21.412C123.895 21.412 122.267 19.635 122.267 16.9862C122.267 14.3375 123.857 12.6081 126.314 12.6081C128.77 12.6081 130.436 14.3279 130.436 16.9862ZM126.366 9.62109C121.815 9.62109 118.873 12.5128 118.873 16.9862C118.873 21.4596 121.815 24.3704 126.366 24.3704C130.917 24.3704 133.802 21.4739 133.802 16.9862C133.802 12.4986 130.884 9.62109 126.366 9.62109Z"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M160.49 9.64939C159.66 9.71197 158.855 9.95812 158.132 10.3701C157.41 10.782 156.787 11.3494 156.31 12.0314V10.283C156.31 10.199 156.293 10.1158 156.261 10.0383C156.229 9.96081 156.181 9.89053 156.121 9.83157C156.062 9.7726 155.991 9.72613 155.913 9.69486C155.835 9.66358 155.751 9.64812 155.667 9.64939H154.192C154.024 9.65063 153.864 9.71779 153.745 9.83635C153.627 9.9549 153.56 10.1153 153.559 10.283V23.7937C153.56 23.9538 153.624 24.1069 153.737 24.2201C153.85 24.3333 154.003 24.3975 154.163 24.3987H156.243C156.403 24.3987 156.556 24.3356 156.669 24.2232C156.783 24.1108 156.847 23.9581 156.848 23.7985L156.872 16.2428C156.872 13.8941 158.686 12.765 160.48 12.6936C160.685 12.7066 160.89 12.6762 161.082 12.6045C161.274 12.5328 161.448 12.4214 161.594 12.2775C161.74 12.1336 161.854 11.9605 161.929 11.7695C162.004 11.5785 162.037 11.3739 162.027 11.1691C162.037 10.9647 162.003 10.7606 161.928 10.5702C161.853 10.3798 161.739 10.2073 161.593 10.0639C161.447 9.92055 161.272 9.80955 161.081 9.73813C160.889 9.66672 160.684 9.63648 160.48 9.64939"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M172.766 15.4244C172.766 15.5053 172.766 15.6864 172.766 15.8198H166.054C166.061 15.3702 166.158 14.9266 166.338 14.5147C166.518 14.1029 166.779 13.731 167.104 13.4206C167.429 13.1103 167.812 12.8678 168.232 12.7072C168.652 12.5466 169.099 12.471 169.548 12.485C171.562 12.485 172.766 13.5855 172.766 15.4339V15.4244ZM169.601 9.65992C165.53 9.65992 162.684 12.666 162.684 16.9679C162.684 21.6271 165.607 24.4093 170.505 24.4093C172.021 24.3432 173.507 23.9704 174.875 23.3135C175.015 23.2498 175.125 23.1346 175.183 22.9919C175.241 22.8491 175.241 22.6897 175.185 22.5465L174.623 20.9982C174.595 20.9207 174.551 20.8497 174.494 20.7897C174.437 20.7297 174.369 20.6819 174.293 20.6493C174.217 20.6167 174.136 20.6 174.053 20.6002C173.971 20.6004 173.889 20.6175 173.814 20.6505C172.767 21.13 171.632 21.3894 170.481 21.4127C167.277 21.4127 166.102 19.6786 166.054 18.1494H174.261C175.556 18.1494 176.108 17.5396 176.108 16.1056C176.108 12.1229 173.614 9.65039 169.601 9.65039"
                fill="currentColor"
                class="primary"
              ></path>
              <path
                d="M191.895 9.9267C191.837 9.84181 191.76 9.77225 191.669 9.72409C191.579 9.67593 191.478 9.65063 191.376 9.65039H189.357C189.231 9.65066 189.109 9.68902 189.005 9.76045C188.901 9.83187 188.822 9.93301 188.777 10.0506L184.863 20.2598C184.839 20.3292 184.793 20.3891 184.732 20.4309C184.671 20.4728 184.599 20.4946 184.525 20.4933C184.452 20.4953 184.379 20.4738 184.318 20.4318C184.258 20.3899 184.212 20.3296 184.187 20.2598L180.265 10.0696C180.22 9.95206 180.14 9.85093 180.036 9.7795C179.933 9.70808 179.81 9.66971 179.684 9.66945H177.68C177.578 9.67005 177.478 9.69554 177.389 9.74371C177.299 9.79187 177.223 9.86123 177.166 9.94576C177.107 10.0286 177.071 10.1251 177.06 10.2259C177.049 10.3268 177.064 10.4288 177.104 10.5222L181.507 21.589C182.207 23.4946 182.821 24.4188 184.445 24.4188H184.664C186.044 24.4188 186.758 23.7042 187.601 21.4794L191.957 10.5222C191.994 10.4284 192.008 10.3268 191.997 10.2263C191.986 10.1258 191.951 10.0295 191.895 9.94576"
                fill="currentColor"
                class="primary"
              ></path>
            </svg>
          </div>
        </v-list-item-title>
        <v-list-item-icon @click.stop="drawer = !drawer">
          <span class="v-btn__content">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              role="img"
              aria-hidden="true"
              class="v-icon__svg"
            >
              <path
                d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
              ></path>
            </svg>
          </span>
        </v-list-item-icon>
      </v-list-item>

      <v-divider class="d-lg-none"></v-divider>

      <v-divider />

      <v-list dense style="text-align: center">
        <v-list-item>
          <a
            href="https:/www.odontoprev.com.br/quem-somos"
            class="v-list-item v-list-item--link theme--light"
            tabindex="0"
            role="listitem"
            style="font-family: 'Noto Sans'; font-size: 14px; font-weight 400; height 36px;"
          >
            <v-list-item-content>
              <v-list-item-title>Quem Somos</v-list-item-title>
            </v-list-item-content>
          </a>
        </v-list-item>
        <v-list-item>
          <a
            href="https:/www.odontoprev.com.br/planos"
            class="v-list-item v-list-item--link theme--light"
            tabindex="0"
            role="listitem"
            style="font-family: 'Noto Sans'; font-size: 14px; font-weight 400; height 36px;"
          >
            <v-list-item-content>
              <v-list-item-title>Nossos planos</v-list-item-title>
            </v-list-item-content>
          </a>
        </v-list-item>
        <v-list-item>
          <a
            href="https://ri.odontoprev.com.br/"
            class="v-list-item v-list-item--link theme--light"
            tabindex="0"
            role="listitem"
            style="font-family: 'Noto Sans'; font-size: 14px; 
            font-weight 400; height 36px;"
          >
            <v-list-item-content>
              <v-list-item-title>Investidores</v-list-item-title>
            </v-list-item-content>
          </a>
        </v-list-item>
        <v-list-item>
          <a
            href="https:/www.odontoprev.com.br/sustentabilidade"
            class="v-list-item v-list-item--link theme--light"
            tabindex="0"
            role="listitem"
            style="font-family: 'Noto Sans'; font-size: 14px; 
            font-weight 400; height 36px;"
          >
            <v-list-item-content>
              <v-list-item-title>ESG</v-list-item-title>
            </v-list-item-content>
          </a>
        </v-list-item>
        <v-list-item>
          <a
            href="https:/www.odontoprev.com.br/carreiras"
            class="v-list-item v-list-item--link theme--light"
            tabindex="0"
            role="listitem"
            style="font-family: 'Noto Sans'; font-size: 14px; 
            font-weight 400; height 36px;"
          >
            <v-list-item-content>
              <v-list-item-title>Carreiras</v-list-item-title>
            </v-list-item-content>
          </a>
        </v-list-item>
        <v-list-item>
          <a
            href="https:/www.odontoprev.com.br/fale-conosco"
            class="v-list-item v-list-item--link theme--light"
            tabindex="0"
            role="listitem"
            style="font-family: 'Noto Sans'; font-size: 14px; 
            font-weight 400; height 36px;"
          >
            <v-list-item-content>
              <v-list-item-title>Fale conosco</v-list-item-title>
            </v-list-item-content>
          </a>
        </v-list-item>
      </v-list>
      <v-col>
        <div class="d-flex align-center wrap mt-8">
          <div id="app_btn_block" color="white" secondary-color="black">
            <p class="text-uppercase text-subtitle-2">Baixe o app:</p>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=br.com.beneficiario.odontoprev&amp;hl=pt_BR"
                class="d-inline-block mb-4"
              >
                <img src="../assets/goo-play.png" alt="" />
              </a>
              <a
                href="https://apps.apple.com/br/app/odontoprev/id829062633"
                class="d-inline-block mb-4"
              >
                <img src="../assets/app-play.png" alt="" />
              </a>
              <v-img
                src="../assets/link-store.png"
                width="98"
                heigth="96"
                aria-label="qrcode"
                contain=""
              >
              </v-img>
            </div>
          </div>
        </div>
      </v-col>
    </v-navigation-drawer>
  </header>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      drawer: false,
      group: null,
      isLogged: this.checkIfIsLogged(),
      versaoF: '',
      versaoB: '',
      userName: '',
    };
  },
  methods: {
    toggleDarkMode: function () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
    },
    login() {
      this.$router.push('/login');
    },
    signout() {
      if (confirm('Deseja realmente realizar o logoff?')) {
        localStorage.removeItem('user_name');
        localStorage.removeItem('cod_consultor');
        localStorage.removeItem('dt_ultima_requisicao');
        this.isLogged = this.checkIfIsLogged();
        this.$router.push('/').catch(() => {});
      }
    },

    checkIfIsLogged() {
      this.userName = localStorage.getItem('user_name');
      let token = localStorage.getItem('cod_consultor');
      if (token && this.$route.name !== 'login') {
        return true;
      } else {
        return false;
      }
    },
  },
  computed: {
    items() {},
    userNameLogged() {
  return this.userName ? this.userName.split(' ')[0] : '';
},
  },
  created() {
    this.$eventBus.$on('logged', () => {
      this.isLogged = this.checkIfIsLogged();
    });
  },
  mounted() {
    this.userName = localStorage.getItem('user_name');
    const theme = localStorage.getItem('dark_theme');
    if (theme) {
      this.$vuetify.theme.dark = theme == 'true';
    }
  },
};
</script>
<style scoped>
.hideScreen {
  display: initial !important;

  @media (max-width: 768px) {
    display: none !important;
  }
}

.showScreen {
  display: none !important;

  @media (max-width: 768px) {
    display: initial !important;
  }
}

.header {
  background-image: url('/src/assets/nav-background.jpg');
}
</style>
